import styled from 'styled-components';

import { DotsIcon } from '../../../../assets';
import { Avatar } from '../../../../components';
import { AvatarVariant } from '../../../../components/Avatar';
import { ThemeProp } from '../../../../theme/Themes';

interface ContainerProps {
  $isToast: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  padding: ${(props: ContainerProps) => (props.$isToast ? '0.5rem' : '1rem 1.25rem 1rem 1rem')};
  width: 100%;
  cursor: pointer;
  background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};

  &:hover {
    background: ${(props: ThemeProp) => props.theme.colors.main.c050};
  }
`;

export const Wrapper = styled.div`
  margin: 0 0.5rem;
  border-radius: 2px;
  &:hover {
    background: ${(props: ThemeProp) => props.theme.colors.greyscale.c700};
  }
`;

export const Line = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
`;

export const AvatarContainer = styled.div`
  position: relative;
  margin-right: 0.5rem;
`;

export const AvatarImage = styled(Avatar).attrs(() => ({
  variant: AvatarVariant.XSMALL,
}))``;

export const UserBlock = styled.div`
  display: flex;
  flex-direction: flex-row;
`;

export const LeftContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
`;

export const Label = styled.span`
  font-weight: ${(props) => props.theme.fontWeight.regular};
  font-size: ${(props) => props.theme.fontSize.xs};
  line-height: 1rem;
  color: ${(props: ThemeProp) => props.theme.colors.greyscale.c200};
  margin-left: 0.25rem;
`;

export const DotIcon = styled(DotsIcon)`
  fill: ${(props) => props.theme.colors.black};
`;

export const RightContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionLink = styled.div`
  font-weight: ${(props) => props.theme.fontWeight.regular};
  font-size: ${(props) => props.theme.fontSize.s};
  line-height: ${(props) => props.theme.lineHeight.m};
  text-decoration-line: underline;
`;

export const DotSeparator = styled.div`
  margin: 0 0.5rem;
  padding: 0 0.5rem;
  font-weight: ${(props) => props.theme.fontWeight.regular};
  font-size: ${(props) => props.theme.fontSize.xs};
  line-height: 1rem;
  color: ${(props) => props.theme.colors.greyscale.c600};
`;

interface VehicleImageContainerProps {
  $display: boolean;
}

export const VehicleImageContainer = styled.div<VehicleImageContainerProps>`
  width: 3.437rem;
  height: 2.563rem;
  border-radius: 0.25rem;
  margin-right: 0.5rem;
  display: ${(props: VehicleImageContainerProps) => (props.$display ? 'flex' : 'none')};
  flex-shrink: 0;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    width: 3rem;
    height: 2.25rem;
  }
`;

export const VehicleImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.25rem;
`;

export const NotificationText = styled.span`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.xs};
  color: ${(props: ThemeProp) => props.theme.colors.white};
`;
